import Comp from "./Results";

export default Comp;
